import React from 'react';
type Props = {
    value: number;
}
export default function Progress(props: Props): JSX.Element {
    const { value } = props;
    return <section className="elementor-section elementor-inner-section elementor-element elementor-element-f3fe4d5 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-element_type="section">
        <div className="elementor-container elementor-column-gap-default">
          <div className="elementor-row">
            <div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-92dd0a4" data-element_type="column">
              <div className="elementor-column-wrap elementor-element-populated">
                <div className="elementor-widget-wrap">
                  <div className="elementor-element elementor-element-bf3388a elementor-widget elementor-widget-progress" data-id="bf3388a" data-element_type="widget" id="orderFormProgress" data-widget_type="progress.default">
                    <div className="elementor-widget-container">
                      <div className="elementor-progress-wrapper progressbar" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={value} aria-valuetext="" style={{ height: "10px" }}>
                        <div className="elementor-progress-bar" data-max="5" style={{ width: `${value}%` }}>
                          <span className="elementor-progress-text" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-604edc8" data-id="604edc8" data-element_type="column">
              <div className="elementor-column-wrap elementor-element-populated">
                <div className="elementor-widget-wrap">
                  <div className="elementor-element elementor-element-3c0a0ba elementor-widget elementor-widget-html" data-id="3c0a0ba" data-element_type="widget" data-widget_type="html.default">
                    <div className="elementor-widget-container" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>;
}